import { ACTION } from '@cvent/react-analytics';

export const viewAchievementDetails = {
  id: 'viewAchievementDetails',
  name: 'Challenge Details',
  type: ACTION,
  attributes: ['gameId', 'achievementId'],
  destinations: ['Mixpanel'],
  objectIdAttribute: 'gameId'
};

export const viewGameRules = {
  id: 'viewGameRules',
  name: 'View Game Rules',
  type: ACTION,
  attributes: ['gameId'],
  destinations: ['Mixpanel'],
  objectIdAttribute: 'gameId'
};

export const playerOptIn = {
  id: 'playerOptIn',
  name: 'Opt-in to Gamification',
  type: ACTION,
  attributes: ['gameId', 'gameName'],
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  objectIdAttribute: 'gameId',
  activityType: 'gamification.opt_in'
};

export const playerOptOut = {
  id: 'playerOptOut',
  name: 'Opt-out of Gamification',
  type: ACTION,
  attributes: ['gameId', 'gameName'],
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  objectIdAttribute: 'gameId',
  activityType: 'gamification.opt_out'
};

export const viewOptOut = {
  id: 'viewOptOut',
  name: 'View Opt-out of Gamification Modal',
  type: ACTION,
  attributes: ['gameId', 'gameName'],
  destinations: ['Mixpanel'],
  objectIdAttribute: 'gameId',
  activityType: 'gamification.view_opt_out'
};
